import React, { createContext, useContext, useEffect, useState } from 'react';

const ADMIN_STORAGE_KEY = 'urumawahini_admin_auth';
const API_BASE = process.env.REACT_APP_API_URL || '';

function buildUrl(path) {
  return `${API_BASE.replace(/\/$/, '')}${path}`;
}

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    try {
      const stored = typeof window !== 'undefined' && window.localStorage
        ? localStorage.getItem(ADMIN_STORAGE_KEY)
        : null;
      setIsAdminLoggedIn(!!stored);
    } catch {
      setIsAdminLoggedIn(false);
    }
    setChecked(true);
  }, []);

  const login = async (email, password) => {
    try {
      const res = await fetch(buildUrl('/api/admin/login'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: String(email || '').trim(), password }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.success) {
        localStorage.setItem(ADMIN_STORAGE_KEY, '1');
        setIsAdminLoggedIn(true);
        return { success: true };
      }
      return {
        success: false,
        message: data.message || 'Invalid email or password',
      };
    } catch {
      return {
        success: false,
        message: 'Cannot reach server. Is the API running?',
      };
    }
  };

  const logout = () => {
    try {
      localStorage.removeItem(ADMIN_STORAGE_KEY);
    } catch {
      // ignore
    }
    setIsAdminLoggedIn(false);
  };

  const value = { isAdminLoggedIn, login, logout, checked };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return ctx;
}

